import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../Services/auth';
import { AlertService } from '../Services/alert';


@Component({
  selector: 'app-requestpwd',
  templateUrl: '../Templates/requestpwd.html',
})


export class RequestPwdComponent {

  email: string;

  // Form submitted?
  submitted:boolean = false;

  constructor(private authService: AuthService,
              private msg: AlertService,
              private router: Router) { }

  requestpwd(): void {

    if (this.submitted) {
      this.msg.error('Form already submitted');
    }

    this.submitted = true;

    this.authService.requestpwd(this.email).subscribe(
      data => { this.msg.success("We sent you an email!") },
      (err: HttpErrorResponse) => {
        if (err.error.non_field_errors) {
          this.msg.error(err.error.non_field_errors);
        } else {
          this.msg.error(err.error);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/requestpwd.ts